"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexContainer = _interopRequireDefault(require("../FlexContainer"));

var _Link = _interopRequireDefault(require("../Link"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Breadcrumbs = function Breadcrumbs(_ref) {
  var className = _ref.className,
      children = _ref.children,
      hasBackArrow = _ref.hasBackArrow,
      isNav = _ref.isNav,
      id = _ref.id;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_FlexContainer["default"].Vertical, {
    id: id,
    className: (0, _classnames["default"])(className, classes.Breadcrumbs, isNav ? classes.NavBreadcrumbs : classes.PageBreadcrumbs)
  }, hasBackArrow && /*#__PURE__*/React.createElement(_Icon["default"], {
    className: isNav ? classes.NavBackArrow : classes.PageBackArrow,
    glyph: "chevron-left"
  }), React.Children.toArray(children).filter(Boolean).map(function (child, index) {
    return React.isValidElement(child) && React.cloneElement(child, {
      className: (0, _classnames["default"])(classes.Link, (0, _defineProperty2["default"])({}, classes.Disabled, child.props.disabled)),
      // @ts-ignore
      'data-clickable': "crumb-".concat(index)
    });
  }));
};

Breadcrumbs.Link = _Link["default"];
var _default = Breadcrumbs;
exports["default"] = _default;
//# sourceMappingURL=index.js.map